(function () {
  'use strict';

  window.dataLayer = window.dataLayer || [];
  var DATA = window.gtmData || {};
  var CURRENCY = DATA.currency || 'USD';

  function push(eventName, ecommerce) {
    window.dataLayer.push({ ecommerce: null });
    window.dataLayer.push({ event: eventName, ecommerce: ecommerce });
  }

  function toNumber(value) {
    var n = parseFloat(value);
    return isNaN(n) ? 0 : n;
  }

  function lineToItem(line) {
    return {
      item_id: String(line.product_id || line.id || ''),
      item_name: line.product_title || line.title || '',
      item_brand: line.vendor || '',
      item_category: line.product_type || '',
      item_variant: line.variant_title || '',
      variant_id: String(line.variant_id || line.id || ''),
      price: toNumber(line.final_price != null ? line.final_price : line.price) / 100,
      quantity: line.quantity || 1,
    };
  }

  function itemsValue(items) {
    return items.reduce(function (sum, it) {
      return sum + toNumber(it.price) * (it.quantity || 1);
    }, 0);
  }

  function trackPageView() {
    if (DATA.product) {
      var p = DATA.product;
      push('view_item', {
        currency: CURRENCY,
        value: toNumber(p.price),
        items: [
          {
            item_id: String(p.item_id),
            item_name: p.item_name,
            item_brand: p.item_brand,
            item_category: p.item_category,
            item_variant: p.item_variant,
            variant_id: String(p.variant_id),
            price: toNumber(p.price),
            quantity: 1,
          },
        ],
      });
    }

    if (DATA.itemList && DATA.itemList.items && DATA.itemList.items.length) {
      push('view_item_list', {
        item_list_id: DATA.itemList.item_list_id,
        item_list_name: DATA.itemList.item_list_name,
        items: DATA.itemList.items.map(function (it) {
          return {
            item_id: String(it.item_id),
            item_name: it.item_name,
            item_brand: it.item_brand,
            item_category: it.item_category,
            price: toNumber(it.price),
            index: it.index,
            item_list_id: DATA.itemList.item_list_id,
            item_list_name: DATA.itemList.item_list_name,
          };
        }),
      });
    }

    if (DATA.cart && DATA.cart.items && DATA.cart.items.length) {
      push('view_cart', {
        currency: CURRENCY,
        value: toNumber(DATA.cart.value),
        items: DATA.cart.items.map(function (it) {
          return {
            item_id: String(it.item_id),
            item_name: it.item_name,
            item_brand: it.item_brand,
            item_category: it.item_category,
            item_variant: it.item_variant,
            variant_id: String(it.variant_id),
            price: toNumber(it.price),
            quantity: it.quantity,
          };
        }),
      });
    }
  }

  function handleAddResponse(json) {
    if (!json) return;
    var lines = json.items && Array.isArray(json.items) ? json.items : [json];
    var items = lines
      .filter(function (l) {
        return l && (l.product_id || l.variant_id || l.id);
      })
      .map(lineToItem);
    if (!items.length) return;
    push('add_to_cart', {
      currency: json.currency || CURRENCY,
      value: itemsValue(items),
      items: items,
    });
  }

  var cartSnapshot = {};

  function indexCart(cart) {
    var map = {};
    if (cart && cart.items) {
      cart.items.forEach(function (line) {
        map[line.key || line.variant_id] = line;
      });
    }
    return map;
  }

  function refreshSnapshot() {
    fetch(rootUrl() + 'cart.js')
      .then(function (r) {
        return r.json();
      })
      .then(function (cart) {
        cartSnapshot = indexCart(cart);
      })
      .catch(function () {});
  }

  function handleChangeResponse(cart) {
    if (!cart || !cart.items) return;
    var after = indexCart(cart);
    Object.keys(cartSnapshot).forEach(function (key) {
      var before = cartSnapshot[key];
      var now = after[key];
      var beforeQty = before.quantity || 0;
      var nowQty = now ? now.quantity || 0 : 0;
      if (nowQty < beforeQty) {
        var removed = lineToItem(before);
        removed.quantity = beforeQty - nowQty;
        push('remove_from_cart', {
          currency: cart.currency || CURRENCY,
          value: toNumber(removed.price) * removed.quantity,
          items: [removed],
        });
      }
    });
    cartSnapshot = after;
  }

  function rootUrl() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  }

  var nativeFetch = window.fetch;
  if (typeof nativeFetch === 'function') {
    window.fetch = function (input, init) {
      var url = typeof input === 'string' ? input : input && input.url ? input.url : '';
      var isAdd = /\/cart\/add(\.js)?(\?|$)/.test(url);
      var isChange = /\/cart\/(change|update)(\.js)?(\?|$)/.test(url);

      var promise = nativeFetch.apply(this, arguments);

      if (isAdd || isChange) {
        promise
          .then(function (response) {
            var clone = response.clone();
            clone
              .json()
              .then(function (json) {
                if (isAdd) handleAddResponse(json);
                if (isChange) handleChangeResponse(json);
              })
              .catch(function () {});
          })
          .catch(function () {});
      }
      return promise;
    };
  }

  var XHR = window.XMLHttpRequest;
  if (XHR && XHR.prototype) {
    var open = XHR.prototype.open;
    var send = XHR.prototype.send;
    XHR.prototype.open = function (method, url) {
      this.__gtmUrl = url || '';
      return open.apply(this, arguments);
    };
    XHR.prototype.send = function () {
      var xhr = this;
      var url = xhr.__gtmUrl || '';
      var isAdd = /\/cart\/add(\.js)?(\?|$)/.test(url);
      var isChange = /\/cart\/(change|update)(\.js)?(\?|$)/.test(url);
      if (isAdd || isChange) {
        xhr.addEventListener('load', function () {
          try {
            var json = JSON.parse(xhr.responseText);
            if (isAdd) handleAddResponse(json);
            if (isChange) handleChangeResponse(json);
          } catch (e) {}
        });
      }
      return send.apply(this, arguments);
    };
  }

  function bindCheckout() {
    document.addEventListener(
      'click',
      function (e) {
        var el = e.target.closest(
          'button[name="checkout"], [name="checkout"], a[href*="/checkout"], .cart__checkout, #checkout'
        );
        if (!el) return;
        beginCheckout();
      },
      true
    );

    document.addEventListener(
      'submit',
      function (e) {
        var form = e.target;
        if (form && form.action && /\/(cart|checkout)/.test(form.action)) {
          var submitter = e.submitter;
          if (submitter && submitter.name === 'checkout') beginCheckout();
        }
      },
      true
    );
  }

  var checkoutFired = false;
  function beginCheckout() {
    if (checkoutFired) return;
    checkoutFired = true;
    fetch(rootUrl() + 'cart.js')
      .then(function (r) {
        return r.json();
      })
      .then(function (cart) {
        var items = (cart.items || []).map(lineToItem);
        push('begin_checkout', {
          currency: cart.currency || CURRENCY,
          value: toNumber(cart.total_price) / 100,
          items: items,
        });
      })
      .catch(function () {
        checkoutFired = false;
      });
  }

  function init() {
    trackPageView();
    refreshSnapshot();
    bindCheckout();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
